import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
import { InvalidPackageToDelete } from '../local/missing-list-product.model';
import { PaymentInformation } from '../local/payment.model';
import { TTransactionType } from './bbva.model';
import { BaseResponseHttp } from './commons.model';
import { CallPlace } from './myActivity.model';
import { PaymentMethod, PaypalOrderCategory } from './ordersresume.model';

export class PendingInvoicesResponse extends BaseResponseHttp {
  response?: PendingInvoices[];
}

export class PendingInvoices {
  invoiceId: number;
  startDate: string;
  totalProducts: number;
  totalPieces: number;
  amountTotal: number;
  amountRemaining: number;
  receiptCreateDate: Date;
  isPaymentProcessed: number;
  paymentMethod: PaymentInformation;
  isSelected?: boolean;
  paymentStatus?: string;
  showCheck?: boolean;
  isOverdue?: boolean;
  createDate?: Date;
  deliverys: string;
  invoiceDelay: number;
  lastValue?: boolean;
  invoiceTax: number;
  invoiceUrlPdf: string[];
  areAnyInProcess: boolean;
  showPendingHeader?: boolean;
  constructor() {
    this.invoiceTax = NumberCons.zero;
    this.invoiceId = NumberCons.zero;
    this.startDate = StringConst.empty;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.amountTotal = NumberCons.zero;
    this.receiptCreateDate = new Date();
    this.isPaymentProcessed = NumberCons.zero;
    this.paymentMethod = new PaymentInformation();
    this.isSelected = BooleanCons.false;
    this.paymentStatus = StringConst.empty;
    this.showCheck = BooleanCons.true;
    this.isOverdue = BooleanCons.false;
    this.deliverys = StringConst.empty;
    this.invoiceDelay = NumberCons.zero;
    this.lastValue = BooleanCons.false;
    this.invoiceUrlPdf = [];
    this.areAnyInProcess = BooleanCons.true;
    this.amountRemaining = NumberCons.zero;
    this.showPendingHeader = BooleanCons.true;
  }
}

export class PayInvoiceWithCard {
  cardCode: string;
  paymentMethod: string;
  cardId: string;
  sesionId: string;
  customerId: string;
  email: string;
  doctorName: string;
  createName: string;
  paymentMethodService: string;
  cardNumber: string;
  invoicesInfo: InvoicesInfo[];
  constructor() {
    this.cardCode = StringConst.empty;
    this.customerId = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.createName = StringConst.empty;
    this.paymentMethod = StringConst.empty;
    this.cardId = StringConst.empty;
    this.sesionId = StringConst.empty;
    this.paymentMethodService = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.invoicesInfo = [];
  }
}

export class PayInvoice {
  cardCode: string;
  customerId: string;
  email: string;
  doctorName: string;
  createName: string;
  paymentMethodService: string;
  invoicesInfo: InvoicesInfo[];
  constructor() {
    this.cardCode = StringConst.empty;
    this.customerId = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.createName = StringConst.empty;
    this.paymentMethodService = StringConst.empty;
    this.invoicesInfo = [];
  }
}

export class PayPaypalInvoice extends PayInvoice {
  transactionId: string;
  isWebHook: boolean;
  orderCategory: PaypalOrderCategory;
  constructor() {
    super();
    this.transactionId = StringConst.empty;
    this.isWebHook = BooleanCons.false;
    this.orderCategory = PaypalOrderCategory.default;
  }
}

export interface PayInvoiceResponse extends BaseResponseHttp {
  response: PaymentInformation;
}

export class CreatePaypalOrderChangePayment {
  transactionId: string;
  oldTransactionId: string;
  customerId: string;
  newPaymentMethod: string;
  cardId: string;
  sesionId: string;
  cardType: string;
  email: string;
  doctorName: string;
  cardNumber: string;
  cardCode: string;
  orderCategory: string;
  totalCost: number;
  constructor() {
    this.transactionId = StringConst.empty;
    this.oldTransactionId = StringConst.empty;
    this.customerId = StringConst.empty;
    this.newPaymentMethod = StringConst.empty;
    this.cardId = StringConst.empty;
    this.sesionId = StringConst.empty;
    this.cardType = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.cardCode = StringConst.empty;
    this.orderCategory = StringConst.empty;
    this.totalCost = NumberCons.zero;
  }
}
export class ChangeMethodToInvoiseRequest {
  transactionId: string;
  customerId: string;
  newPaymentMethod: string;
  cardId: string;
  sesionId: string;
  cardType: string;
  email: string;
  doctorName: string;
  cardNumber: string;
  cardCode: string;
  packageValidation: DeletePackages;
  constructor() {
    this.transactionId = StringConst.empty;
    this.customerId = StringConst.empty;
    this.newPaymentMethod = StringConst.empty;
    this.cardId = StringConst.empty;
    this.sesionId = StringConst.empty;
    this.cardType = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.cardCode = StringConst.empty;
    this.packageValidation = new DeletePackages();
  }
}

export class PaypalInvoiceChangePayment extends ChangeMethodToInvoiseRequest {
  transactionId: string;
  isWebHook: boolean;
  oldTransactionId: string;
  orderCategory: PaypalOrderCategory;
  constructor() {
    super();
    this.oldTransactionId = StringConst.empty;
    this.transactionId = StringConst.empty;
    this.isWebHook = BooleanCons.false;
    this.orderCategory = PaypalOrderCategory.default;
  }
}

export class CreateBBVAOrder extends ChangeMethodToInvoiseRequest {
  oldTransactionId: string;
  isWebHook: boolean;
  orderCategory: PaypalOrderCategory;
  createName: string;
  paymentMethod: string;
  paymentMethodService: string;
  invoicesInfo: InvoicesInfo[];
  constructor() {
    super();
    this.oldTransactionId = StringConst.empty;
    this.isWebHook = BooleanCons.false;
    this.orderCategory = PaypalOrderCategory.default;
    this.createName = StringConst.empty;
    this.paymentMethod = StringConst.empty;
    this.paymentMethodService = StringConst.empty;
    this.invoicesInfo = [];
  }
}

export class DeletePackages {
  invalidItemCodes: string[];
  isAllShopCartInvalid: boolean;
  invalidContainerCodes: string[];
  constructor() {
    this.invalidItemCodes = [];
    this.isAllShopCartInvalid = BooleanCons.false;
    this.invalidContainerCodes = [];
  }
}

export class PackageValidation {
  isAllShopCartInvalid: boolean;
  invalidItemCodes: InvalidPackageToDelete[];
  constructor() {
    this.isAllShopCartInvalid = BooleanCons.false;
    this.invalidItemCodes = [];
  }
}
export class PayInvoiceBank {
  cardResponse: string;
  creationDate: string;
  amount: number;
  status: string;
  description: string;
  transactionType: string;
  operationType: string;
  method: string;
  bankAccount: string;
  authorization: string;
  orderId: string;
  customerId: string;
  conciliated: string;
  dueDate: Date;
  id: string;
  paymentBreakdown: string;
  paymentMethod: PaymentMethod;
  constructor() {
    this.cardResponse = StringConst.empty;
    this.creationDate = StringConst.empty;
    this.amount = NumberCons.zero;
    this.status = StringConst.empty;
    this.description = StringConst.empty;
    this.transactionType = StringConst.empty;
    this.operationType = StringConst.empty;
    this.method = StringConst.empty;
    this.bankAccount = StringConst.empty;
    this.authorization = StringConst.empty;
    this.orderId = StringConst.empty;
    this.customerId = StringConst.empty;
    this.conciliated = StringConst.empty;
    this.dueDate = new Date();
    this.id = StringConst.empty;
    this.paymentBreakdown = StringConst.empty;
    this.paymentMethod = new PaymentMethod();
  }
}

export class InvoicesInfo {
  totalProducts: number;
  totalPieces: number;
  totalCost: number;
  invoiceId: number;
  deliverys: string;
  createDate: Date;
  invoiceTax: number;
  constructor() {
    this.invoiceTax = NumberCons.zero;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.totalCost = NumberCons.zero;
    this.invoiceId = NumberCons.zero;
    this.deliverys = StringConst.empty;
    this.createDate = new Date();
  }
}

export interface DetailInvoiceResponse extends BaseResponseHttp {
  response: DetailInvoiceInfo;
}

export class DetailInvoiceInfo {
  totalCost: number;
  totalTax: number;
  subtotal: number;
  status: string;
  invoicesInfo: InvoiceDetailData[];
  paymentMethod: PaymentInformation;
  callPlace: CallPlace;
  constructor() {
    this.totalCost = NumberCons.zero;
    this.totalTax = NumberCons.zero;
    this.subtotal = NumberCons.zero;
    this.status = StringConst.empty;
    this.invoicesInfo = [];
    this.paymentMethod = new PaymentInformation();
    this.callPlace = CallPlace.default;
  }
}

export class InvoicePaymentMethod {
  method: string;
  cardType: string;
  cardId: string;
  cardNumber: string;
  constructor() {
    this.method = StringConst.empty;
    this.cardType = StringConst.empty;
    this.cardId = StringConst.empty;
    this.cardNumber = StringConst.empty;
  }
}
export class InvoiceDetailData {
  totalCost: number;
  invoiceId: number;
  invoiceDate: Date;
  constructor() {
    this.totalCost = NumberCons.zero;
    this.invoiceId = NumberCons.zero;
    this.invoiceDate = new Date();
  }
}

export class RenewCodeInvoiceRequest {
  transactionId: string;
  email: string;
  doctorName: string;
  customerId: string;
  constructor() {
    this.transactionId = StringConst.empty;
    this.email = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.customerId = StringConst.empty;
  }
}
